import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap } from "@phosphor-icons/react";
import { SchoolLogoRow } from "@/components/admin/SchoolsPanel";

// Compact panel for school admins: manage their own school's logo, which brands
// the app and course certificates for the school's staff & students.
export default function SchoolLogoCard() {
  const [schools, setSchools] = useState([]);
  const load = () => api.get("/schools").then((r) => setSchools(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="card max-w-lg" data-testid="school-logo-card">
      <div className="flex items-center gap-2 font-display font-bold mb-1">
        <GraduationCap size={18} weight="duotone" color="#84CC16" /> School logo
      </div>
      <p className="text-sm text-[#000000] mb-3">
        Your logo appears on course certificates and replaces the platform logo across the app for your school's staff and students.
      </p>
      {schools.map((s) => (
        <div key={s.id}>
          <div className="text-xs font-semibold text-[#000000] mb-1">{s.name}</div>
          <SchoolLogoRow school={s} onChanged={load} />
        </div>
      ))}
      {schools.length === 0 && <div className="text-sm text-[#000000]">No school linked to your account yet.</div>}
    </div>
  );
}
